import React from 'react';
import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import useStoreStore from 'zustands/useStoreStore';
import styleGuide from 'constants/styleGuide';
import NavBar from 'components/navBar/NavBar';
import SideNavBar from 'components/sideNavBar/SideNavBar';
import './withSideBarAndNavBar.scss';

const ScreenWrap = styled.div`
  height: calc(100vh - 70px);
  background-color: ${styleGuide.palette.background};
  overflow-x: auto;
`;
const Screen = styled.div`
  padding: 60px 42px;
  width: 100%;
  min-width: 1250px;
  height: 100%;
  overflow-y: auto;
`;

type Props = { children: React.ReactNode; clickSelectBusinessEstab?: Function };

const Layout: React.FC<Props> = ({ children, clickSelectBusinessEstab }) => {
  const location = useLocation();
  const { storeSeq } = useStoreStore((state) => state);

  const mobileScreenViewList = ['/salary-detail'];
  const isMobileScreenView = mobileScreenViewList.includes(location.pathname) && isMobile;

  if (isMobileScreenView) {
    return <>{children ? children : ''}</>;
  }
  return (
    <>
      <div className="navbarLayout">
        <NavBar />
      </div>
      <div className="screenColumn">
        {storeSeq !== '' && <SideNavBar />}
        <ScreenWrap style={{ width: storeSeq !== '' ? `calc(100vw - 280px)` : '100%' }}>
          <Screen id="screen">{children ? children : ''}</Screen>
        </ScreenWrap>
      </div>
    </>
  );
};

export default Layout;
